import { render, staticRenderFns } from "./KkFilePreview.vue?vue&type=template&id=36b1c7d4&scoped=true"
import script from "./KkFilePreview.vue?vue&type=script&lang=js"
export * from "./KkFilePreview.vue?vue&type=script&lang=js"
import style0 from "./KkFilePreview.vue?vue&type=style&index=0&id=36b1c7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b1c7d4",
  null
  
)

export default component.exports